import { sessionStore } from '@gto/session'

export const clearAdminSession = (): void => {
  sessionStore.getState().clearAccessToken()
  localStorage.removeItem('user_refresh')
}
